import { useNavigate, useLocation } from "react-router-dom";
import { Wordmark } from "./Wordmark";
import { siteConfig } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const footerItems = [
  { key: "home", href: "#home" },
  { key: "about", href: "#about" },
  { key: "whatWeDo", href: "#what-we-do" },
  { key: "contact", href: "#contact" },
];

export const Footer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useLang();

  const go = (href) => {
    if (pathname !== "/") {
      navigate("/" + href);
      return;
    }
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="bg-[#1A1C19] text-[#F4F3EF]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <Wordmark light />
            <p className="mt-6 text-sm text-[#B5A68B] tracking-wide">
              {t.footer.descriptor}
            </p>
            <p className="text-sm text-[#B9B8B2]">{t.common.location}</p>
          </div>

          <nav className="flex flex-col md:items-end gap-4">
            {footerItems.map((l) => (
              <button
                key={l.href}
                data-testid={`footer-link-${l.href.replace("#", "")}`}
                onClick={() => go(l.href)}
                className="text-sm text-[#B9B8B2] hover:text-[#F4F3EF] transition-colors text-left md:text-right"
              >
                {t.nav[l.key]}
              </button>
            ))}
            <button
              data-testid="footer-link-privacy"
              onClick={() => navigate("/privacy")}
              className="text-sm text-[#B9B8B2] hover:text-[#F4F3EF] transition-colors text-left md:text-right"
            >
              {t.footer.privacy}
            </button>
            <button
              data-testid="footer-link-terms"
              onClick={() => navigate("/terms")}
              className="text-sm text-[#B9B8B2] hover:text-[#F4F3EF] transition-colors text-left md:text-right"
            >
              {t.footer.terms}
            </button>
          </nav>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 space-y-5">
          <p className="text-xs leading-relaxed text-[#8A8A85] max-w-3xl">
            {t.footer.disclaimer}
          </p>
          <p className="text-xs text-[#8A8A85]">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};
